import type { TransferDirection } from "antd/es/transfer";
import { useState } from "react";
import { IDataTransfer, ITransferProps } from "./CloneSettings";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { ISavedMinerSetting } from "@store/savedMinerSettings/actionTypes";
import { addSavedSetting } from "@store/savedMinerSettings/action";
import { useSavedSettings } from "@utils/hooks/useSavedSettings";
import Item from "antd/es/list/Item";
import { useSettings } from "@utils/hooks/useMe";
import { TransferKey } from "antd/es/transfer/interface";

interface ICloneSettingsControl {
  readonly targetKeys: KeysType[];
  readonly selectedKeys: KeysType[];
  readonly savedSettings: ISavedMinerSetting[];

  handleChange(
    newTargetKeys: TransferKey[], //string[],
    direction: TransferDirection,
    moveKeys: TransferKey[], //string[]
  ): void;

  handleSelectChange(
    sourceSelectedKeys: TransferKey[], //string[],
    targetSelectedKeys: TransferKey[], //string[]
  ): void;

  renderItem(item: IDataTransfer): string;
  onSave(): void;
}

export type KeysType = keyof ISavedMinerSetting;

export const useCloneSettingsControl = (
  props: ITransferProps
): ICloneSettingsControl => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const savedSettings = useSavedSettings();
  const poolSettings = useSettings();
  const [targetKeys, setTargetKeys] = useState<KeysType[]>([]);
  const [selectedKeys, setSelectedKeys] = useState<KeysType[]>(
    props.dataSource.map((item) => item.key)
  );

  const handleChange = (
    newTargetKeys: KeysType[],
    direction: TransferDirection,
    moveKeys: KeysType[]
  ) => {
    setTargetKeys(newTargetKeys);
  };

  const handleSelectChange = (
    sourceSelectedKeys: KeysType[],
    targetSelectedKeys: KeysType[]
  ) => {
    setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
  };

  const renderItem = (item: IDataTransfer) => {
    switch (item.title) {
      case "notes":
        return formatMessage({ id: "locations.table.notes" });
      case "speed_drop":
        return "% " + formatMessage({ id: "rate_drop.speed_drop" });
      case "miner_type":
        return formatMessage({ id: "machines.settings.type" });
      case "mining_persent":
        return formatMessage({ id: "machines.settings.admin_income" });
      case "default_speed":
        return formatMessage({ id: "machines.settings.speed_default" });
      case "miner_plan":
        return formatMessage({ id: "machines.settings.plan" });
      case "location":
        return formatMessage({ id: "machines.settings.location" });
      case "hash":
        return formatMessage({ id: "machines.table.algo" });
      case "admin_setting":
        return formatMessage({ id: "machines.admin_mining" });
      // case "setting":
      //   return formatMessage({ id: "machines.table.pool_settings" });
      case "customer":
        return formatMessage({ id: "machines.table.customer" });
      default:
        return item.title;
    }
  };

  const onSave = () => {
    const settings = targetKeys.reduce((acc, item) => {
      const currItem = props.dataSource.find((data) => data.key === item);
      let value = currItem?.value;

      if (item === "notes") {
        value = `[CLONED] ${currItem?.value}`;
      }

      return Object.assign(acc, { [item]: value });
    }, {}) as Omit<ISavedMinerSetting, "cloned_miner">;
    dispatch(addSavedSetting({ ...settings, cloned_miner: props.miner }));
  };

  return {
    targetKeys,
    selectedKeys,
    savedSettings,

    handleChange,
    handleSelectChange,
    renderItem,
    onSave,
  };
};
